// extracted by mini-css-extract-plugin
export default {"violation":"ComplianceIssuesTable_violation__41eSG"};